export const portuguese = {
  title: {
    welcome: "Bem-vindo",
    welcomeNext: "Vamos começar com alguns passos simples.",
  },
  signup: {
    name: "Nome completo",
    last_name: "Sobrenomes",
    job_position: "Cargo",
    country: "País",
    country_options: {
      MX: "México",
      US: "Estados Unidos",
    },
    email: "E-mail corporativo",
    phone: "Telefone (opcional)",
    password: "Senha",
    repeat_password: "Confirmar senha",
    company: "Nome da empresa",
    website: "Site",
    terms_agree: "Concordo com os termos e condições",
    subscribe: "Quero assinar o boletim informativo",
    register: "Cadastrar-me",
  },
  customPhoneInput: "Digite seu telefone",
};
